export default {
  // Endpoints
  loginEndpoint: '/api/login',
  registerEndpoint: '/api/register',
  refreshEndpoint: '/api/tokentime',
  logoutEndpoint: '/api/logout',
  // tokenTimeEndpoint: '/v1/api/tokentime',

  // This will be prefixed in authorization header with token
  // e.g. Authorization: Bearer <token>
  tokenType: 'Bearer',

  // Value of this property will be used as key to store JWT token in storage
  storageTokenKeyName: 'accessToken',
  storageRefreshTokenKeyName: 'refreshToken',
}
